export interface AigwRuntimeConfig {
  apiUrl: string;
  logtoEndpoint: string;
  logtoAppId: string;
  otelEndpoint: string;
  envName: string;
}

declare global {
  interface Window {
    __AIGW_CONFIG__?: AigwRuntimeConfig;
  }
}

export function getConfig(): AigwRuntimeConfig {
  const cfg = window.__AIGW_CONFIG__;
  if (!cfg) {
    throw new Error('window.__AIGW_CONFIG__ not set — /config.js did not load before the bundle');
  }
  return cfg;
}
